<template>
	<div class="tab_otp">
		<div v-if="otps.length < 1" class="">
			<div class="item_list_area">
				<div class="item_list">
					<p>
						{{ $t('rtr_mypage-data.text1') }}<br />
						{{ $t('rtr_mypage-data.text2') }}
						{{ $t('rtr_mypage-data.text3') }}
					</p>
				</div>
				<div class="arrow">
					<img src="@/assets/images/icon/arrow_red.png" alt="" />
				</div>
				<div class="item_list">
					<p>
						{{ $t('rtr_mypage-data.text4') }}<br />
						{{ secret }}<br />
						{{ $t('rtr_mypage-data.text5') }}
					</p>
				</div>
				<div class="arrow">
					<img src="@/assets/images/icon/arrow_red.png" alt="" />
				</div>
				<div class="item_list">
					<p>
						{{ $t('rtr_mypage-data.text6') }}
					</p>
				</div>
				<div class="arrow">
					<img src="@/assets/images/icon/arrow_red.png" alt="" />
				</div>
				<div class="item_list">
					<p>
						{{ $t('rtr_mypage-data.text7') }}
					</p>
				</div>
			</div>
			<div class="rectangle">
				<Qrcode
					id="qr"
					:color="{ dark: '#000000ff', light: '#ffffffff' }"
					type="image/png"
					:quality="1"
					:margin="1"
					:value="qrUri"
					class="qr_img"
				/>
			</div>
			<div class="item_list2_area">
				<div class="item_list2 mb_15">
					<h2 class="item_list2_title">
						{{ $t('rtr_mypage-data.text8') }}
					</h2>
					<div class="otp_key_area" @click="copyOtp">
						<p class="item_list2_text">
							{{ secret }}
						</p>
					</div>
				</div>
				<div class="item_list2">
					<h2 class="item_list2_title">
						{{ $t('rtr_mypage-data.text8') }}
						{{ $t('rtr_mypage-data.text11') }}
					</h2>
					<input
						type="text"
						v-model="token"
						:placeholder="$t('rtr_mypage-data.text12')"
					/>
				</div>
			</div>
			<div class="button_area mt_10 mb_10">
				<button class="button_bg_red" @click="activeOtpHandler">
					{{ $t('button.otp') }}
				</button>
			</div>
		</div>
		<div v-else class="card mb_0">
			<div class="item_list2">
				<h2 class="item_list2_title">
					{{ $t('rtr_mypage-data.text13') }}
				</h2>
				<input
					type="text"
					v-model="token"
					:placeholder="$t('rtr_mypage-data.text12')"
				/>
			</div>
			<div class="button_area mt_10">
				<button class="button_bg_red" @click="inactiveOtp">
					{{ $t('button.otp_disabled') }}
				</button>
			</div>
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div class="button_area">
			<button class="fc_red oneBtn" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import { commonError } from '@/common/dialog';
import { fetchOtpConfig } from '@/api/config';
import { authenticator } from 'otplib';
import { mapState } from 'vuex';
import { createOtp, deleteOtp } from '@/api/otp';
import ModalMessage from '@/components/Layout/ModalMessage';
import useClipboard from 'vue-clipboard3';

export default {
	name: 'Data',
	components: { ModalMessage },
	data() {
		return {
			otpConfig: [],
			secret: '',
			token: '',
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
		};
	},
	computed: {
		...mapState('auth', ['member_info']),
		...mapState('auth', ['otps']),
		qrUri() {
			if (this.otps.length) {
				return `otpauth://totp/${this.member_info.email_address}${this.otps.length}?secret=${this.secret}&issuer=${window.document.domain}`;
			} else {
				return `otpauth://totp/${this.member_info.email_address}?secret=${this.secret}&issuer=${window.document.domain}`;
			}
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.secret = authenticator.generateSecret();
			this.fetchOtpConfig();
		},
		async fetchOtpConfig() {
			const { config } = await fetchOtpConfig().catch(commonError);
			this.otpConfig = config;
		},
		activeOtpHandler() {
			this.activeOtp();
		},
		async activeOtp() {
			const token = this.token.replace(/\D/g, '');
			if (!this.validation()) return;
			await createOtp(token, this.secret)
				.then(() => {
					this.$store.dispatch('auth/getOtps');
				})
				.then(() => {
					window.scrollTo(0, 0);
					this.init();
					this.token = '';
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.set_otp');
					this.messageModal = true;
				})
				.catch(commonError);
		},
		async inactiveOtp() {
			const token = this.token.replace(/\D/g, '');
			if (!this.validation()) return;
			await deleteOtp(this.otps[0].seq, token)
				.then(() => {
					this.$store.dispatch('auth/getOtps');
				})
				.then(() => {
					window.scrollTo(0, 0);
					this.init();
					this.token = '';
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.deactivation_otp');
					this.messageModal = true;
				})
				.catch(commonError);
		},
		validation() {
			if (!this.token) {
				this.modalIcon = 'error';
				this.modalStatusMessage = this.$t('modal.message.set_code');
				this.messageModal = true;
				return false;
			}
			return true;
		},
		copyOtp() {
			try {
				useClipboard().toClipboard(this.secret);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
	},
};
</script>
